<template>
  <div id="app">
    <div style="display: flex;flex-wrap: wrap;justify-content: space-between;margin: 50px 20px;">
      <HelloWorld 
        v-for="cube in dataSet"
        :numOfCube="3"
        :block-size="60"
        :border-size="5"
        :margin="8"
        block-color="#4CAF50"
        border-color="#795548"
        :strr="cube[0]"
        :meth="cube[1]"
      />
    </div>

  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data(){
    return {
      dataSet:[['01000,00101,01110,01100,00010', "R U R' U R U2' R' "],
['00000,10110,01110,00101,01000', "R U2 R' U' R U' R' "],
['01000,00110,01110,00110,01000', "r U R' U' r' F R F' "],
['00000,10110,01110,01100,00010', "F' r U R' U' r' F R "],
['00000,01110,01110,00100,01010', "R2 D R' U2 R D' R' U2 R' "],
['01010,00100,01110,00100,01010', "R U2 R' U' R U R' U' R U' R' "],
['00010,10100,01110,10100,00010', "R U2' R2' U' R2 U' R2' U2' R "],
['00100,10010,01110,10010,00100', "F R U R' U' F' "],
['01100,00010,01110,00010,01100', "R U R' U' R' F R F' "],
['01100,00001,10110,10110,00000', "r' U2' R U R' U r "],
['00000,10110,10110,00001,01100', "r U2 R' U' R U' r' "],
['00100,10001,01110,01010,00100', "R U R2' U' R' F R U R U' F' "],
['00000,01101,10101,01101,00000', "R' U' R' F R F' U R "],
['00100,01001,01101,00110,01000', "R' U' R U' R' U R U l U' R' U x "],
['01000,00110,01101,01001,00100', "R U R' U R U' R' U' R' F R F' "],
['00000,01110,01101,01010,00100', "r U R' U' r' R U R U' R' "],
['00100,01010,01110,01010,00100', "R U R' U' r R' U R U' r' "],
['00100,10010,10110,10110,00000', "f R U R' U' f' "],
['00100,01001,01101,01101,00000', "y R' U' F' U F R "],
['01100,00010,10110,00110,01000', "R U B' U' R' U R B R' "],
['01000,00110,10110,00010,01100', "R' U' F U R U' R' F' R "],
['00110,10000,01110,10000,00110', "f (R U R' U')2 f' "],
['00100,10001,01110,10001,00100', "r' U' r (U' R' U R)2 r' U r "],
['01000,00101,10101,00101,01000', "(R' U' R U' R' U) y' R' U R B "],
['00000,10101,10101,10101,00000', "y R' F R U R U' R2' F' R2 U' R' U R U R' "],
['00010,10100,01101,00010,01100', "R U R' U' R' F R2 U R' U' F' "],
['01100,00010,01101,10100,00010', "R U R' U R' F R F' R U2' R' "],
['00100,01001,10110,00110,01000', "R U2' R2' F R F' R U2' R' "],
['00000,01101,01101,00010,01100', "F R U' R' U' R U R' F' "],
['01100,00001,01110,01000,00110', "r U' r' U' r U r' y' R' U R "],
['00110,10000,01110,00010,01100', "R' F R U R' F' R F U' F' "],
['00100,10010,01110,00001,01100', "r U r' R U R' U' r U' r' "],
['01100,00001,01110,10010,00100', "r' U' r R' U' R U r' U r "],
['01000,00110,01101,00010,01100', "R U R' U' R U' R' F' U' F R U R' "],
['00000,10101,01101,01010,00100', "F U R U2 R' U' R U2 R' U' F' "],
['01010,00100,01101,01010,00100', "R U R' U R U2' R' F R U R' U' F' "],
['00100,01010,01101,00100,01010', "R' U' R U' R' U2 R F R U R' U' F' "],
['00010,10100,01101,10000,00110', "F (R U R' U')2 F' "],
['01000,00101,10110,00001,01100', "F' (L' U' L U)2 F "],
['00010,10100,10110,10000,00110', "r U' r2' U r2 U r2' U' r "],
['00110,10000,10110,10100,00010', "r' U r2 U' r2' U' r2 U r' "],
['00100,10001,10110,10101,00000', "r' U' R U' R' U R U' R' U2 r "],
['00000,10101,10110,10001,00100', "r U R' U R U' R' U R U2' r' "],
['01000,00101,01101,01000,00110', "r U R' U R U2' r' "],
['00110,01000,01101,00101,01000', "r' U' R U' R' U2 r "],
['01100,00001,10110,01100,00010', "M R U R' U R U2 R' U M' "],
['00010,01100,10110,00001,01100', "M' R' U' R U' R' U2 R U' M "],
['01100,00010,01110,01001,00100', "L F' L' U' L U F U' L' "],
['00110,01000,01110,10010,00100', "R' F R U R' U' F' U R "],
['00100,10001,10101,10001,00100', "R U2' R2' F R F' U2' R' F R F' "],
['00110,10000,10101,10000,00110', "F R U R' U' F' f R U R' U' f' "],
['01100,00001,10101,10010,00100', "f R U R' U' f' U' F R U R' U' F' "],
['00100,10010,10101,00001,01100', "f R U R' U' f' U F R U R' U' F' "],
['00100,01010,10101,00000,01110', "y R U2' R2' F R F' U2' M' U R U' r' "],
['00100,01010,10101,10001,00100', "M U R U R' U' M' R' F R F' "],
['00110,01000,10101,10010,00100', "R U R' U R' F R F' U2' R' F R F' "],
['00100,01010,10101,01010,00100', "M U R U R' U' M2' U R U' r' "]]
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body{
  padding: 0;
  margin: 0;
}
</style>
